import {
  WistiaPlayer,
  type WistiaPlayerElement,
  type WistiaPlayerProps,
} from "@wistia/wistia-player-react";
import { type ComponentPropsWithRef, type ForwardedRef } from "react";

// Additional parameters can be found here https://docs.wistia.com/docs/embed-options-and-plugins#options
export type WistiaOptions = Omit<WistiaPlayerProps, "mediaId"> & {
  fitStrategy?: "contain" | "cover";
};

export interface WistiaVideoProps
  extends Pick<ComponentPropsWithRef<"video">, "ref"> {
  videoId: string;
  options?: WistiaOptions;
  onPlay?: () => void;
}

const defaultOptions: WistiaOptions = {
  autoplay: true,
};

export default function WistiaVideo(props: WistiaVideoProps) {
  const { videoId, options: customOptions, onPlay, ref } = props;

  const handlePlay = () => {
    onPlay?.();
  };

  return (
    <WistiaPlayer
      ref={ref as ForwardedRef<WistiaPlayerElement>}
      mediaId={videoId}
      onPlay={handlePlay}
      {...defaultOptions}
      {...customOptions}
    />
  );
}
